
import { Mixins, Component, Watch } from "vue-property-decorator";
import SymptomIndex from "./index.vue";

@Component({ name: 'symptoms-brandIndex',
    components: { SymptomIndex }
})
export default class SymptomsBrandIndex extends Mixins() {

}
